var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      model: {
        value: _vm.activeName,
        callback: function ($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName",
      },
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "企业介绍", name: "first" } },
        [_c("intro")],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "建设项目", name: "second" } },
        [_vm.activeName === "second" ? _c("project") : _vm._e()],
        1
      ),
      _c(
        "el-tab-pane",
        { attrs: { label: "企业荣誉", name: "fifth" } },
        [_vm.activeName === "fifth" ? _c("honour") : _vm._e()],
        1
      ),
      _vm.graphic.code == "441704001000000020001"
        ? _c(
            "el-tab-pane",
            { attrs: { label: "发展历程", name: "third" } },
            [_vm.activeName === "third" ? _c("fzlc") : _vm._e()],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }